var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbar-item',{staticClass:"ym-tabbbar-column-item",class:[
               ("type-" + _vm.type),
               { 'is-disabled': _vm.disabled },
               { 'is-round': _vm.round } ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }